<mat-form-field
  [id]="id()"
  appearance="outline"
  [subscriptSizing]="showBottomMargin() ? 'fixed' : 'dynamic'"
  floatLabel="always"
  [class]="
    (selectBoxOptions().dbKey && isAdmin()) || selectBoxOptions().gridId
      ? 'sia-input sia-small-width ' + inputClass()
      : 'sia-input sia-inputs-full ' + inputClass()
  "
  outsideClick
  [outsideClickActive]="isOpen()"
  (clickedOutside)="closeSelectOptions()"
>
  <mat-select
    [disableOptionCentering]="true"
    [siaTooltip]="fieldErrors()"
    [disable]="!visibleTooltip()"
    siaTooltipClass="sia-tooltip"
    [ngModel]="value()"
    (ngModelChange)="onNgModelChange($event)"
    [disabled]="isDisabled()"
    [id]="id() ?? ''"
    [tabIndex]="tabDisabled() ? '-1' : '0'"
    (openedChange)="openChange($event)"
    (keydown)="onKeyDown($event)"
    (blur)="onBlur($event)"
    #selectInput
    [placeholder]="emptyElementLabel()"
  >
    @if (
      value() &&
      (shouldShowSelectedValue() ||
        (isSelectedInFiltered() && (!isOpen() || !isSelectedRendered())))
    ) {
      <mat-option [value]="value()" style="height: 0px; display: none">
        @if (selectBoxOptions().translateData) {
          {{ selectedValue()?.description || '' | siaTranslate }}
        } @else {
          {{ selectedValue()?.description || '' }}
        }
      </mat-option>
    }
    @if (showVisibilityButton()) {
      <button
        mat-icon-button
        [siaTooltip]="
          showAll() ? 'Nascondi disabitati' : 'Mostra tutti i valori'
        "
        tabindex="-1"
        (click)="toggleVisibility()"
        class="sia-select-box-view"
      >
        <mat-icon>
          {{ showAll() ? 'visibility_off' : 'visibility' }}
        </mat-icon>
      </button>
    }
    <mat-option>
      <ngx-mat-select-search
        class="w-full"
        [disableInitialFocus]="!!isMobile()"
        [placeholderLabel]="'Cerca' | siaTranslate"
        [formControl]="selectFilterCtrl"
        [noEntriesFoundLabel]="'Nessun elemento trovato' | siaTranslate"
        ngDefaultControl
        (focusin)="onSearchFocus()"
        (click)="onSearchFocus()"
      >
      </ngx-mat-select-search>
    </mat-option>
    @if (!filteredDataSource().length && scriptButtonEmptyResearch() !== '') {
      <div class="flex w-full flex-row px-2 py-1">
        <button
          mat-button
          (click)="execScriptButtonEmptyResearch()"
          class="w-full"
        >
          <span>{{ 'Aggiungi' | siaTranslate }} </span>
          <mat-icon>add</mat-icon>
        </button>
      </div>
    }
    <cdk-virtual-scroll-viewport
      class="virtual-scroll w-full !overflow-x-hidden truncate"
      [style.height.px]="viewportHeight"
      [itemSize]="viewportItemSize"
      [maxBufferPx]="viewportItemSize * 10"
      [minBufferPx]="viewportItemSize * 10"
    >
      @if (!selectFilterCtrl.value && !selectBoxOptions().disableEmptyElement) {
        <mat-option [value]="null" class="sia-select-option">
          {{ emptyElementLabel() }}
        </mat-option>
      }
      <mat-option
        *cdkVirtualFor="let field of filteredDataSource(); trackBy: trackById"
        [value]="field.id"
        class="sia-select-option w-full truncate"
        [class]="field?.disabled ? 'sia-select-option--disabled' : ''"
      >
        @if (selectBoxOptions().translateData) {
          {{ field.description | siaTranslate }}
        } @else {
          {{ field.description }}
        }
      </mat-option>
    </cdk-virtual-scroll-viewport>
  </mat-select>

  <mat-label
    >{{ label() | siaTranslate }}
    @if (info()) {
      <span
        [siaTooltip]="info() ?? ''"
        position="right"
        class="sia-info"
        [innerHTML]="infoIcon()"
      >
      </span>
    }
  </mat-label>

  @if (showBottomMargin()) {
    <mat-hint
      sia-error-hint
      [statusMessage]="statusMessage()"
      [statusMessages]="statusMessages()"
    ></mat-hint>
  }
</mat-form-field>
<!-- PULSANTE DB EDIT -->

@if (selectBoxOptions().dbKey && isAdmin() && !selectBoxOptions().gridId) {
  <div class="admin-tools">
    <div class="admin-tools-sql-view">
      <button
        mat-icon-button
        [siaTooltip]="selectBoxOptions().dbKey ?? 'Modifica Vista'"
        tabindex="-1"
        (click)="updateSqlView()"
      >
        <span
          class="material-symbols-outlined admin-tools-sql-view__icon"
          title="Modifica Vista"
        >
          table
        </span>
      </button>
    </div>
  </div>
} @else if (selectBoxOptions().gridId) {
  <div class="admin-tools">
    <div class="admin-tools-sql-view">
      <button
        mat-icon-button
        [siaTooltip]="'Visualizza griglia'"
        [disabled]="isDisabled()"
        tabindex="-1"
        (click)="showRadar()"
      >
        <span
          class="material-symbols-outlined admin-tools-sql-view__icon"
          title="Visualizza griglia"
        >
          table
        </span>
      </button>
    </div>
  </div>
}
